/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../../constants';
const elementName = `${COMPONENT_NAME_PREFIX}button-toggle-group`;
const attributes = {
    VALUE: 'value',
    MULTIPLE: 'multiple',
    MANDATORY: 'mandatory',
    VERTICAL: 'vertical',
    STRETCH: 'stretch',
    DISABLED: 'disabled',
    DENSE: 'dense'
};
const classes = {
    VERTICAL: 'forge-button-toggle-group--vertical',
    STRETCH: 'forge-button-toggle-group--stretch'
};
const selectors = {
    ROOT: '.forge-button-toggle-group'
};
const events = {
    CHANGE: `${elementName}-change`
};
export const BUTTON_TOGGLE_GROUP_CONSTANTS = {
    elementName,
    attributes,
    classes,
    selectors,
    events
};
